import React, {CSSProperties, useEffect, useRef} from 'react';

interface ChangeTextWithColorAndImageProps {
  text: string;
  textStyle?: CSSProperties;
}

const ChangeTextWithColorAndImage: React.FC<
  ChangeTextWithColorAndImageProps
> = ({text, textStyle}) => {
  const elRef = useRef<HTMLDivElement>(null);
  //   const staticFilesManager = new StaticFilesManager(); //TODO: Implement image

  useEffect(() => {
    if (text && elRef.current) {
      //TODO: Implement image
      //   const staticServeUrl = staticFilesManager.getUrlStaticServer(
      //     CStaticResourceType.IMAGES,
      //   );

      // Color Logic -> <#FF0000;Text>
      const colorRegex = /<#([a-fA-F0-9]{6});(.*?)>/g;
      const coloredText = text.replace(colorRegex, (_match, color, content) => {
        return `<span style="color: #${color}">${content}</span>`;
      });

      //TODO: Implement image
      // Image Logic -> [image.jpg,100,50]
      //   const imageRegex = /\[([^\]]+),(\d+),(\d+)\]/g;
      //   const textWithImages = coloredText.replace(
      //     imageRegex,
      //     (_match, fileName, width, height) => {
      //       return `<img class="card-element" src="${staticServeUrl}/${fileName}" width="${width}" height="${height}" >`;
      //     },
      //   );

      // Link Logic -> {https://example.com,Click here}
      const linkRegex = /{([^,]+),([^}]+)}/g; // Matches {url,text}
      const finalText = coloredText.replace(
        linkRegex,
        (_match, url, linkText) => {
          return `<a href="${url}" target="_blank">${linkText}</a>`;
        },
      );

      elRef.current.innerHTML = finalText;
    }
  }, [text]);

  return (
    <div
      ref={elRef}
      style={textStyle}></div>
  );
};

export default ChangeTextWithColorAndImage;
